import { toDateString } from "../date_utils";
import { TableDef } from "../table_def";
import { apiClient } from "./api";

const leaf_searchable_columns = [
    "seq",
    // "model.seq", 
    "turbine.name",
];

// Use API client for leaf operations
export const listLeaf = async (currentFieldId, filter = null) => {
    try {
        // Extract numeric field ID if it's in SurrealDB format
        let fieldId = currentFieldId;
        if (typeof currentFieldId === 'string' && currentFieldId.includes(':')) {
            fieldId = currentFieldId.split(':')[1];
        }
        
        return await apiClient.getLeavesByField(fieldId, filter);
    } catch (error) {
        console.error('Failed to load leaves:', error);
        if (error.message && (error.message.includes('404') || error.message.includes('500'))) {
            console.warn('Leaf API error. Please ensure backend is running and API is implemented.');
        }
        return [];
    }
};

export const LeafDef = new TableDef("leaf", {
    seq: {
        label: "编号",
    },
    model: {
        label: "叶片型号",
        display: (item) => item.model?.seq,
    },
    turbine: {
        label: "风机",
        display: (item) => item.turbine?.name,
    },
    attach_id: {
        label: "挂载位置",
        display: (item) => item.attach_id?.toString(),
    },
    installed_at: {
        label: "挂载时间",
        display: (item) => toDateString(item?.installed_at),
    },
});
